module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis13-a5e5987e0ac0e500469fa1ce2495eba1.jpg";